@let isLoading = !!(isLoading$ | async);
@let isInsideSummary = $isInsideSummary();
@let isDesktop = deviceService.isDesktop$ | async;
@let canDeleteComments = permissionService.canDeleteComments$ | async;
@let selectMode = $selectMode();

@let user = user$ | async;

@if (isDesktop && isInsideSummary) {
  <header class="flex items-center justify-between mb-4 px-[20px]">
    <p class="x-font-body-1-bold">
      {{ 'request_form.summary.comments' | translate }}
      @if (requestComments.length) {
        <span
          tuiBadge
          class="mx-1 font-medium! mb-1 entities-counter-badge"
          size="l"
          >{{ requestComments.length }}</span
        >
      }
    </p>

    @if (canDeleteComments && requestComments.length) {
      <div class="flex gap-1">
        @if (selectMode) {
          @if (selectedComments.size > 0) {
            <tui-icon
              [style.border-width.rem]="0.25"
              icon="@tui.copy"
              class="cursor-pointer h-[32px]! w-[32px]!"
              tuiHintAppearance="dark"
              tuiHintDirection="end-top"
              (click)="copySelectedComments()"
            />
            <tui-icon
              [style.border-width.rem]="0.25"
              icon="@tui.x"
              class="text-(--x-color-red) cursor-pointer h-[32px]! w-[32px]!"
              tuiHintAppearance="dark"
              tuiHintDirection="end-top"
              (click)="deleteSelectedComments()"
            />
          }
        }

        <tui-icon
          [ngClass]="
            selectMode
              ? 'x-bg-green text-white!'
              : 'x-white-secondary x-icon-btn text-[#494C62FF] self-end'
          "
          class="rounded-full h-[32px]! w-[32px]! cursor-pointer text-base"
          icon="@tui.pencil"
          (click)="toggleCommentsSelectMode()"
        ></tui-icon>
      </div>
    }
  </header>
}

@if (
  !isDesktop && isInsideSummary && canDeleteComments && requestComments.length
) {
  <div class="flex gapx-1 mb-3 justify-end px-[20px]">
    @if (selectMode) {
      @if (selectedComments.size > 0) {
        <tui-icon
          [style.border-width.rem]="0.25"
          icon="@tui.copy"
          class="cursor-pointer h-[32px]! w-[32px]!"
          tuiHintAppearance="dark"
          tuiHintDirection="end-top"
          (click)="copySelectedComments()"
        />
        <tui-icon
          [style.border-width.rem]="0.25"
          icon="@tui.x"
          class="text-(--x-color-red) cursor-pointer h-[32px]! w-[32px]!"
          tuiHintAppearance="dark"
          tuiHintDirection="end-top"
          (click)="deleteSelectedComments()"
        />
      }
    }

    <tui-icon
      [ngClass]="
        selectMode
          ? 'x-bg-green text-white!'
          : 'x-white-secondary x-icon-btn text-[#494C62FF] self-end'
      "
      class="rounded-full h-[32px]! w-[32px]! cursor-pointer text-base"
      icon="@tui.pencil"
      (click)="toggleCommentsSelectMode()"
    ></tui-icon>
  </div>
}

<tui-scrollbar
  #commentsContainer
  [ngClass]="{
    'overflow-y-auto': isInsideSummary,
    'h-[calc(100%-145px)]': isDesktop,
  }"
>
  @for (
    comment of requestComments || [];
    track comment.id;
    let index = $index
  ) {
    @let prevSameAuthor = prevCommentWithSameAuthor(comment, index);
    @let nextSameAuthor = nextCommentWithSameAuthor(comment, index);

    @if (isInsideSummary) {
      @if (!prevSameAuthor) {
        <div
          class="x-font-body-5-bold x-text-dark-main flex justify-between mb-2.5 px-[20px]"
        >
          <span class="flex items-center">
            {{
              isUserPopulated(comment.createdId)
                ? comment.createdId.fullname
                : ('request_form.summary.anonymous' | translate)
            }}
            @let authorName =
              isUserPopulated(comment.createdId)
                ? comment.createdId.fullname
                : '';
            <!-- Без фото — инициалы на цветном фоне (в v3 был tui-avatar с autoColor) -->
            <span
              [tuiAvatar]="authorName | tuiInitials"
              class="h-[16px]! w-[16px]! min-w-0! p-0! ms-2.5 text-[7px]! text-(--tui-text-primary)"
              size="xs"
              [round]="true"
              [style.background]="authorName | tuiAutoColor"
            >
              @if (getAvatarUrl(comment.createdId); as avatarUrl) {
                <img alt="" [src]="avatarUrl" />
              }
            </span>
          </span>
          <span class="me-2.5">{{
            comment.createdAt | date: 'dd.MM.yyyy'
          }}</span>
        </div>
      }
      <div
        class="relative flex items-center px-[20px]"
        [ngClass]="{
          'ps-0': selectMode,
          'mb-6': !nextSameAuthor,
          'mb-2': nextSameAuthor,
          'w-[calc(100%-20px)]': selectMode,
        }"
      >
        @if (selectMode) {
          <input
            tuiCheckbox
            type="checkbox"
            [ngModel]="isCommentSelected(comment.id)"
            (ngModelChange)="
              toggleCommentSelection(comment.id, !isCommentSelected(comment.id))
            "
            class="mx-[4px] w-[12px]! h-[12px]! small-checkbox"
          />
        }
        <!-- Пузырь комментария: обычный блок на всю ширину (tuiChip в v5 однострочный и сжимается по тексту) -->
        <div
          class="block rounded-xl px-[15px] pt-[12px] pb-[14px] x-font-body-5 whitespace-pre-wrap w-full x-text-dark-main-important bg-(--x-color-grayBG) relative"
          (click)="
            toggleCommentSelection(comment.id, !isCommentSelected(comment.id))
          "
          [ngClass]="{
            'cursor-pointer': selectMode,
          }"
        >
          <div
            [innerHTML]="comment.text | safeHtml: 1"
            class="overflow-auto"
          ></div>
          <span class="x-text-not-active absolute top-0 right-2">{{
            comment.createdAt | date: 'hh:mm'
          }}</span>
        </div>
      </div>
    } @else {
      <div class="md:container md:w-2/3 mt-4.5">
        <div
          class="x-card x-card_size_m x-white mb-2"
          [ngClass]="{
            'ms-8':
              user?.id ===
              (isUserPopulated(comment.createdId)
                ? comment.createdId.id
                : comment.createdId),
          }"
        >
          <div class="x-card__content">
            @if (canDeleteComments) {
              <div class="x-card__figure">
                <button
                  appearance="icon"
                  iconStart="@tui.x"
                  tuiIconButton
                  type="button"
                  size="m"
                  [disabled]="$loading()"
                  tuiHintAppearance="dark"
                  [tuiHint]="'Удалить комментарий'"
                  (click)="deleteComment(comment.id)"
                ></button>
              </div>
            }
            <div>
              <div class="x-card__title">
                <div class="flex">
                  <span
                    [tuiAvatar]="
                      (isUserPopulated(comment.createdId)
                        ? comment.createdId.fullname
                        : ''
                      ) | tuiInitials
                    "
                    [round]="false"
                    class="m-4"
                  >
                    @if (getAvatarUrl(comment.createdId); as avatarUrl) {
                      <img alt="" [src]="avatarUrl" />
                    }
                  </span>
                  <div class="flex flex-col justify-center">
                    <div class="text-sm text-gray-400">
                      {{ comment.createdAt | date: 'medium' }}
                    </div>
                    <div class="typo-ui-s font-medium">
                      {{
                        isUserPopulated(comment.createdId)
                          ? comment.createdId.fullname
                          : ''
                      }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="x-card__paragraph ml-4 typo-ui-s font-semibold overflow-auto"
                [innerHTML]="comment.text"
              ></div>
            </div>
          </div>
        </div>
      </div>
    }
  } @empty {
    <x-empty-block
      [title]="'request_form.comments.no_comments' | translate"
      class="mt-4.5 block"
    />
  }
</tui-scrollbar>
@if (
  (permissionService.canAddComments$ | async) && !(isLoading && isInitialLoad)
) {
  @if (isInsideSummary) {
    <div class="relative px-[20px]">
      <!-- Как в v3: белое поле с плавающей подписью, стрелка отправки внутри поля справа снизу -->
      <tui-textfield class="w-full x-white" [tuiTextfieldCleaner]="false">
        <label tuiLabel>{{
          'request_form.comments.new_comment_placeholder' | translate
        }}</label>
        <textarea
          tuiTextarea
          [formControl]="newCommentText"
          id="newCommentText"
          (keydown.enter)="isDesktop ? addComment() : null"
          [min]="2"
          [max]="6"
          class="pe-10!"
        ></textarea>
      </tui-textfield>
      @if (this.newCommentText.valid && this.newCommentText.value) {
        <tui-icon
          icon="@tui.arrow-up"
          class="absolute! right-[28px] bottom-2 z-[1] x-bg-green rounded-full text-white cursor-pointer size-6 text-base"
          (click)="addComment()"
        ></tui-icon>
      }
    </div>
  } @else {
    <div
      class="x-card x-card_size_m x-white md:container md:w-2/3 mt-4"
      [tuiSkeleton]="isLoading && isInitialLoad"
    >
      <p class="x-card__category">{{ user?.fullname }}</p>
      <tui-textfield class="mt-4">
        <textarea
          tuiTextarea
          [formControl]="newCommentText"
          id="newCommentText"
          [min]="2"
          [max]="6"
          [placeholder]="
            'request_form.comments.new_comment_placeholder' | translate
          "
        ></textarea>
      </tui-textfield>
      <button
        tuiButton
        class="mt-4"
        [disabled]="newCommentText.invalid || $loading()"
        (click)="addComment()"
        [loading]="$loading()"
      >
        {{ 'request_form.comments.send_button' | translate }}
      </button>
    </div>
  }
}
